import config from "@/config";
import http from "@/utils/request";

export default {
	list: {
		url: `${config.API_URL}/admin/order/index`,
		name: "订单列表",
		post: async function (params) {
			return await http.post(this.url, params);
		},
	},
	updateSalesApproval: {
		url: `${config.API_URL}/admin/order/updateSalesApproval`,
		name: "更新售后审核记录",
		post: async function (params, config = {}) {
			return await http.post(this.url, params, config);
		},
	},
	getOrderDetailList: {
		url: `${config.API_URL}/admin/order/getOrderDetailList`,
		name: "订单商品明细",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	serviceList: {
		url: `${config.API_URL}/admin/order/getUserServiceList`,
		name: "服务记录列表",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	success: {
		url: `${config.API_URL}/admin/order/completeUserService`,
		name: "上传交付文件",
		post: async function (params) {
			return await http.post(this.url, params);
		},
	},
	service: {
		url: `${config.API_URL}/admin/order/uploadUserService`,
		name: "上传手机号/姓名列表",
		post: async function (params) {
			return await http.post(this.url, params);
		},
	},
	userService: {
		url: `${config.API_URL}/admin/order/storeUserService`,
		name: "编辑",
		post: async function (params) {
			return await http.post(this.url, params);
		},
	},

	distributionList: {
		url: `${config.API_URL}/admin/order/getDistributionList`,
		name: "分销订单",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	getMySelfList: {
		url: `${config.API_URL}/admin/order/getMySelfList`,
		name: "相关订单",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	confirmDistributionStatus: {
		url: `${config.API_URL}/admin/order/confirmDistributionStatus`,
		name: "确认状态",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	allGoods: {
		url: `${config.API_URL}/admin/goods/orderGoodsList`,
		name: "订单实体商品列表",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	WaitPayGoodsInfo: {
		url: `${config.API_URL}/admin/order/getWaitPayGoodsInfo`,
		name: "结算页",
		post: async function (params) {
			return await http.post(this.url, params);
		},
	},
	payGoodsOrder: {
		url: `${config.API_URL}/admin/order/payGoodsOrder`,
		name: "下单",
		post: async function (params) {
			return await http.post(this.url, params);
		},
	},
	addressList: {
		url: `${config.API_URL}/admin/user/getUserAddress`,
		name: "收货地址",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	setUserAddress: {
		url: `${config.API_URL}/admin/user/setUserAddress`,
		name: "新增/编辑地址",
		post: async function (params) {
			return await http.post(this.url, params);
		},
	},

	store: {
		url: `${config.API_URL}/admin/order/paymentSettlement`,
		name: "订单结款",
		post: async function (params) {
			return await http.post(this.url, params);
		},
	},
	audit: {
		url: `${config.API_URL}/admin/order/refundOrder`,
		name: "售后审核",
		post: async function (params) {
			return await http.post(this.url, params);
		},
	},
	goods: {
		list: {
			url: `${config.API_URL}/admin/order/getGoodsOrderList`,
			name: "获取订单列表",
			post: async function (params, config = {}) {
				return await http.post(this.url, params, config);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/order/getGoodsOrderDetail`,
			name: "订单详情",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		updataStatus: {
			url: `${config.API_URL}/admin/order/enable`,
			name: "修改订单状态",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		store: {
			url: `${config.API_URL}/admin/order/paymentSettlement`,
			name: "订单结款",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		cancel: {
			url: `${config.API_URL}/admin/order/cancelGoodsOrder`,
			name: "取消订单",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		update: {
			url: `${config.API_URL}/admin/order/updateGoodsOrder`,
			name: "修改订单信息",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		cancelexpress: {
			url: `${config.API_URL}/admin/order/cancelexpress`,
			name: "取消发货",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		storeGoodsOrderMark: {
			url: `${config.API_URL}/admin/order/storeGoodsOrderMark`,
			name: "编辑订单备注",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		storeGoodsOrderUser: {
			url: `${config.API_URL}/admin/order/storeGoodsOrderUser`,
			name: "订单转移",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		log: {
			url: `${config.API_URL}/api/ly/sales/approval/log`,
			name: "订单日志",
			get: async function (id) {
				return await http.get(`${this.url}/${id}`);
			},
		},
		storeGoodsOrderCoupon: {
			url: `${config.API_URL}/admin/order/storeGoodsOrderCoupon`,
			name: "添加/编辑订单优惠券",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		storeGoodsOrderQf: {
			url: `${config.API_URL}/admin/order/storeGoodsOrderQf`,
			name: "使用全返券",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		storeGoodsOrderLogistics: {
			url: `${config.API_URL}/admin/order/storeGoodsOrderLogistics`,
			name: "修改订单物流",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		completed: {
			url: `${config.API_URL}/admin/order/completeOrder`,
			name: "订单完成",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		updateGoodsPrice: {
			url: `${config.API_URL}/admin/order/storeGoodsOrderPrice`,
			name: "修改商品价格",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		orderDiffPriceUpdateGoods: {
			url: `${config.API_URL}/admin/order/orderDiffPriceUpdateGoods`,
			name: "补差价更换商品",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		takeDelivery: {
			url: `${config.API_URL}/admin/order/takeDeliveryOfOrder`,
			name: "订单收货",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		splitSonPackageOrder: {
			url: `${config.API_URL}/app/test_simulate/splitSonPackageOrder`,
			name: "补充拆单",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		deleteOrder: {
			url: `${config.API_URL}/admin/order/deleteOrder`,
			name: "删除订单",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		revokeSales: {
			url: `${config.API_URL}/ly/sales/approval/revoke`,
			name: "撤销售后申请",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		revokeExchange: {
			url: `${config.API_URL}/admin/sale_exchange/exit`,
			name: "撤销退换申请",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		createOrderCoreProcessing: {
			url: `${config.API_URL}/admin/order/createOrderCoreProcessing`,
			name: "订单核心处理",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
	},
	// |
	customerPayment: {
		list: {
			url: `${config.API_URL}/api/ly/sales/approval/bank`,
			name: "获取客户收款账户",
			get: async function (userId) {
				return await http.get(`${this.url}/${userId}`);
			},
		},
		add: {
			url: `${config.API_URL}/api/ly/sales/approval/add/bank`,
			name: "添加客户收款账户",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
	},
	express: {
		list: {
			url: `${config.API_URL}/admin/order/express_list`,
			name: "获取物流公司",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		send: {
			url: `${config.API_URL}/admin/order/express`,
			name: "订单发货",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
	},
	return: {
		list: {
			url: `${config.API_URL}/admin/return_order/getReturnOrder`,
			name: "售后订单列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		page: {
			url: `${config.API_URL}/api/ly/sales/page`,
			name: "售后订单列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/return_order/getReturnOrderDetail`,
			name: "售后订单详情",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		audit: {
			url: `${config.API_URL}/admin/return_order/handleReturnOrder`,
			name: "售后订单审核",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
	},
	exchange: {
		page: {
			url: `${config.API_URL}/admin/sale_exchange/list`,
			name: "换货订单列表",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		getOrderDetailSKU: {
			url: `${config.API_URL}/admin/sale_exchange/getOrderDetailSKU`,
			name: "获取订单商品SKU信息",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		getGoodsList: {
			url: `${config.API_URL}/admin/sale_exchange/getGoodsList`,
			name: "换货可选实体商品列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		add: {
			url: `${config.API_URL}/admin/sale_exchange/add`,
			name: "申请换货",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		audit: {
			url: `${config.API_URL}/admin/sale_exchange/audit`,
			name: "填写快递单号",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
	},
	wealth: {
		list: {
			url: `${config.API_URL}/admin/order/getWealthOrderList`,
			name: "获取测评订单",
			post: async function (params, config = {}) {
				return await http.post(this.url, params, config);
			},
		},
	},
	service: {
		activation: {
			url: `${config.API_URL}/admin/order/activationUserService`,
			name: "激活手机号/姓名",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		phone: {
			url: `${config.API_URL}/admin/order/uploadUserService`,
			name: "激活手机号",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
	},
};
